import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/pro-regular-svg-icons/faChartBar';

// FontAwesome regular (outlined) chart-bar icon. Wrapped to match the
// component-with-no-props contract NavIcon expects.
const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
`;

export default function ChartBar() {
  return <StyledIcon icon={faChartBar} />;
}
